/* eslint-disable promise/param-names */
import Vue from 'vue'
import axios from 'axios'
import {
    GET_CATEGORIES_ERROR, GET_CATEGORIES_REQUEST, GET_CATEGORIES_SUCCESS,
    ADD_CATEGORIES_ERROR, ADD_CATEGORIES_REQUEST, ADD_CATEGORIES_SUCCESS,
    ADD_FORUMARTICLE_ERROR, ADD_FORUMARTICLE_REQUEST, ADD_FORUMARTICLE_SUCCESS,
    GET_FORUMARTICLES_ERROR, GET_FORUMARTICLES_REQUEST, GET_FORUMARTICLES_SUCCESS,
    GET_FORUMARTICLE_SUCCESS, GET_FORUMARTICLE_REQUEST, GET_FORUMARTICLE_ERROR,
    ADD_COMMENT_ERROR, ADD_COMMENT_REQUEST, ADD_COMMENT_SUCCESS,
    SEND_COACHING_REQUEST, SEND_COACHING_ERROR, SEND_COACHING_SUCCESS,
    ADD_NEWS_REQUEST, ADD_NEWS_ERROR, ADD_NEWS_SUCCESS,
    GET_NEWS_ERROR, GET_NEWS_REQUEST, GET_NEWS_SUCCESS,
    GET_PRIORITY_NEWS_ERROR, GET_PRIORITY_NEWS_REQUEST, GET_PRIORITY_NEWS_SUCCESS
} from './actiontypes';
import exchangeApi from '../../_services/api/exchange';

const state = {
    category: {},
    categories: {},
    articles: {},
    article: {},
    pnew: {},
    status: '',
    errors: [],
    news: [],
    hasLoadedOnce: false,
};

const getters = {
    categories: state => state.categories,
    news: state => state.news,
    pnew: state => state.pnew
};

const actions = {
    [GET_PRIORITY_NEWS_REQUEST]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(GET_PRIORITY_NEWS_REQUEST);
            exchangeApi.getPriorityNews()
                .then((response) => {
                    if (response.success === true) {
                        commit(GET_PRIORITY_NEWS_SUCCESS, response.data);
                        resolve(response);
                    } else {
                        commit(GET_PRIORITY_NEWS_ERROR, response);
                        reject(response.error);
                    }
                })
                .catch((error) => {
                    commit(GET_PRIORITY_NEWS_ERROR, error);
                    reject(error);
                });
        });
    },
    [GET_CATEGORIES_REQUEST]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(GET_CATEGORIES_REQUEST);
            exchangeApi.getCategories(payload)
                .then((response) => {
                    if (response.success === true) {
                        commit(GET_CATEGORIES_SUCCESS, response.data);
                        resolve(response);
                    } else {
                        commit(GET_CATEGORIES_ERROR, response);
                        reject(response.error);
                    }
                })
                .catch((error) => {
                    commit(GET_CATEGORIES_ERROR, error);
                    reject(error);
                });
        });
    },
    [GET_NEWS_REQUEST]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(GET_NEWS_REQUEST);
            exchangeApi.getNews(payload)
                .then((response) => {
                    if (response.success === true) {
                        commit(GET_NEWS_SUCCESS, response.data);
                        resolve(response);
                    } else {
                        commit(GET_NEWS_ERROR, response);
                        reject(response.error);
                    }
                })
                .catch((error) => {
                    commit(GET_NEWS_ERROR, error);
                    reject(error);
                });
        });
    },
    [ADD_NEWS_REQUEST]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(ADD_NEWS_REQUEST);
            exchangeApi.addNews(payload)
                .then((response) => {
                    if (response.success === true) {
                        commit(ADD_NEWS_SUCCESS, response.data);
                        resolve(response);
                    } else {
                        commit(ADD_NEWS_ERROR, response);
                        reject(response.error);
                    }
                })
                .catch((error) => {
                    commit(ADD_NEWS_ERROR, error);
                    reject(error);
                });
        });
    },
    [GET_FORUMARTICLE_REQUEST]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(GET_FORUMARTICLE_REQUEST);
            exchangeApi.getForumArticle(payload)
                .then((response) => {
                    if (response.success === true) {
                        commit(GET_FORUMARTICLE_SUCCESS, response.data);
                        resolve(response);
                    } else {
                        commit(GET_FORUMARTICLE_ERROR, response);
                        reject(response.error);
                    }
                })
                .catch((error) => {
                    commit(GET_FORUMARTICLE_ERROR, error);
                    reject(error);
                });
        });
    },
    [GET_FORUMARTICLES_REQUEST]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(GET_FORUMARTICLES_REQUEST);
            exchangeApi.getForumArticles(payload)
                .then((response) => {
                    if (response.success === true) {
                        commit(GET_FORUMARTICLES_SUCCESS, response.data);
                        resolve(response);
                    } else {
                        commit(GET_FORUMARTICLES_ERROR, response);
                        reject(response.error);
                    }
                })
                .catch((error) => {
                    commit(GET_FORUMARTICLES_ERROR, error);
                    reject(error);
                });
        });
    },
    [SEND_COACHING_REQUEST]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(SEND_COACHING_REQUEST);
            exchangeApi.sendCoaching(payload)
                .then((response) => {
                    if (response.success === true) {
                        commit(SEND_COACHING_SUCCESS, response.data);
                        resolve(response);
                    } else {
                        commit(SEND_COACHING_ERROR, response);
                        reject(response.error);
                    }
                })
                .catch((error) => {
                    commit(SEND_COACHING_ERROR, error);
                    reject(error);
                });
        });
    },
    [ADD_CATEGORIES_REQUEST]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(GET_CATEGORIES_REQUEST);
            exchangeApi.addCategory(payload)
                .then((response) => {
                    if (response.success === true) {
                        commit(ADD_CATEGORIES_SUCCESS, response.data);
                        resolve(response);
                    } else {
                        commit(ADD_CATEGORIES_ERROR, response);
                        reject(response.error);
                    }
                })
                .catch((error) => {
                    commit(ADD_CATEGORIES_ERROR, error);
                    reject(error);
                });
        });
    },
    [ADD_COMMENT_REQUEST]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(ADD_COMMENT_REQUEST);
            exchangeApi.addComment(payload)
                .then((response) => {
                    if (response.success === true) {
                        commit(ADD_COMMENT_SUCCESS, response.data);
                        resolve(response);
                    } else {
                        commit(ADD_COMMENT_ERROR, response);
                        reject(response.error);
                    }
                })
                .catch((error) => {
                    commit(ADD_COMMENT_ERROR, error);
                    reject(error);
                });
        });
    },
    [ADD_FORUMARTICLE_REQUEST]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(ADD_FORUMARTICLE_REQUEST);
            exchangeApi.addForumArticle(payload)
                .then((response) => {
                    if (response.success === true) {
                        commit(ADD_FORUMARTICLE_SUCCESS, response.data);
                        resolve(response);
                    } else {
                        commit(ADD_FORUMARTICLE_ERROR, response);
                        reject(response.error);
                    }
                })
                .catch((error) => {
                    commit(ADD_FORUMARTICLE_ERROR, error);
                    reject(error);
                });
        });
    },
};

const mutations = {
    [GET_CATEGORIES_REQUEST]: (state) => {
        state.status = 'loading';
    },
    [GET_CATEGORIES_SUCCESS]: (state, response) => {
        state.status = 'success';
        state.token = response.token;
        state.hasLoadedOnce = true;
        Vue.set(state, 'categories', response.categories);
    },
    [GET_PRIORITY_NEWS_REQUEST]: (state) => {
        state.status = 'loading';
    },
    [GET_PRIORITY_NEWS_SUCCESS]: (state, response) => {
        state.status = 'success';
        state.token = response.token;
        state.hasLoadedOnce = true;
        Vue.set(state, 'pnew', response.new);
    },
    [GET_PRIORITY_NEWS_ERROR]: (state, response) => {
        state.status = 'error';
        state.hasLoadedOnce = true;
        Vue.set(state, 'errors', response.error);
    },
    [GET_NEWS_REQUEST]: (state) => {
        state.status = 'loading';
    },
    [GET_NEWS_SUCCESS]: (state, response) => {
        state.status = 'success';
        state.token = response.token;
        state.hasLoadedOnce = true;
        Vue.set(state, 'news', response.news);
    },
    [GET_NEWS_ERROR]: (state, response) => {
        state.status = 'error';
        state.hasLoadedOnce = true;
        Vue.set(state, 'errors', response.error);
    },
    [ADD_NEWS_REQUEST]: (state) => {
        state.status = 'loading';
    },
    [ADD_NEWS_SUCCESS]: (state, response) => {
        state.status = 'success';
        state.token = response.token;
        state.hasLoadedOnce = true;
    },
    [ADD_NEWS_ERROR]: (state, response) => {
        state.status = 'error';
        state.hasLoadedOnce = true;
        Vue.set(state, 'errors', response.error);
    },
    [GET_FORUMARTICLE_REQUEST]: (state) => {
        state.status = 'loading';
    },
    [GET_FORUMARTICLE_SUCCESS]: (state, response) => {
        state.status = 'success';
        state.token = response.token;
        state.hasLoadedOnce = true;
        Vue.set(state, 'article', response.article);
    },
    [GET_FORUMARTICLE_ERROR]: (state, response) => {
        state.status = 'error';
        state.hasLoadedOnce = true;
        Vue.set(state, 'errors', response.error);
    },
    [GET_FORUMARTICLES_REQUEST]: (state) => {
        state.status = 'loading';
    },
    [GET_FORUMARTICLES_SUCCESS]: (state, response) => {
        state.status = 'success';
        state.token = response.token;
        state.hasLoadedOnce = true;
        Vue.set(state, 'category', response.category);
    },
    [GET_FORUMARTICLES_ERROR]: (state, response) => {
        state.status = 'error';
        state.hasLoadedOnce = true;
        Vue.set(state, 'errors', response.error);
    },
    [SEND_COACHING_REQUEST]: (state) => {
        state.status = 'loading';
    },
    [SEND_COACHING_SUCCESS]: (state, response) => {
        state.status = 'success';
        state.token = response.token;
        state.hasLoadedOnce = true;
    },
    [SEND_COACHING_ERROR]: (state, response) => {
        state.status = 'error';
        state.hasLoadedOnce = true;
        Vue.set(state, 'errors', response.error);
    },
    [ADD_CATEGORIES_REQUEST]: (state) => {
        state.status = 'loading';
    },
    [ADD_CATEGORIES_SUCCESS]: (state, response) => {
        state.status = 'success';
        state.token = response.token;
        state.hasLoadedOnce = true;
    },
    [ADD_CATEGORIES_ERROR]: (state, response) => {
        state.status = 'error';
        state.hasLoadedOnce = true;
        Vue.set(state, 'errors', response.error);
    },
    [ADD_COMMENT_REQUEST]: (state) => {
        state.status = 'loading';
    },
    [ADD_COMMENT_SUCCESS]: (state, response) => {
        state.status = 'success';
        state.token = response.token;
        state.hasLoadedOnce = true;
    },
    [ADD_COMMENT_ERROR]: (state, response) => {
        state.status = 'error';
        state.hasLoadedOnce = true;
        Vue.set(state, 'errors', response.error);
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
